import {
  PRODUCT_CATEGORY_STATUS_MESSAGES,
  ProductCategoryStatusMessages,
} from "./product-categories-status.messages";
import {
  PRODUCT_CATEGORIES_TABLE_MESSAGES,
  ProductCategoriesTableMessages,
} from "./product-categories-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ProductCategoriesMessages = SidebarMessages &
  PopoverMessages &
  ActionButtonMessages &
  ProductCategoryStatusMessages &
  ProductCategoriesTableMessages & {
    //Titles messages
    pageTitle: string;
    breadCrumbTitle: string;

    //Button messages
    addCategoryButton: string;
  };

export const PRODUCT_CATEGORIES_MESSAGES: ProductCategoriesMessages = {
  //Titles messages
  pageTitle: "Categorias",
  breadCrumbTitle: "Categorias",

  //Button messages
  addCategoryButton: "Nova categoria",

  ...PRODUCT_CATEGORIES_TABLE_MESSAGES,
  ...PRODUCT_CATEGORY_STATUS_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...POPOVER_MESSAGES,
};
